import { render, staticRenderFns } from "./LeiloesDestaque.vue?vue&type=template&id=2dcd129e"
import script from "./LeiloesDestaque.vue?vue&type=script&lang=js"
export * from "./LeiloesDestaque.vue?vue&type=script&lang=js"
import style0 from "./LeiloesDestaque.vue?vue&type=style&index=0&id=2dcd129e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports